import { defineComponent as _defineComponent } from 'vue'
import VimeoPlayer from "./vimeo-player.vue";
import ChatPanel from "./chat-panel.vue";
import BackgroundImage from "./background-image.vue";
import { TimeDataKey } from "./time-data";
import type { TimeData } from "./time-data";
import { inject } from "vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'main-screen',
  setup(__props, { expose }) {
  expose();

const { hours, minutes } = inject(TimeDataKey) as TimeData;

const addZero = (num: number) => {
  if (num >= 10) return num.toString();
  return "0" + num;
};

const __returned__ = { hours, minutes, addZero, VimeoPlayer, ChatPanel, BackgroundImage, TimeDataKey, inject }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})